import {createReducer} from '@reduxjs/toolkit'
import {Field, replaceZapState, selectCurrency, setDestinationType, setRecipient, setZapInState, switchCurrencies, typeInput, ZapInState} from './actions'

export interface ZapState {
  readonly independentField: Field
  readonly typedValue: string
  readonly [Field.INPUT]: {
    readonly currencyId: string | undefined
  }
  readonly [Field.OUTPUT]: {
    readonly currencyId: string | undefined
  }
  // the typed recipient address or ENS name, or null if swap should go to sender
  readonly recipient: string | null
  readonly destinationType: string | null
  readonly zapInState: ZapInState | null
}

const initialState: ZapState = {
  independentField: Field.INPUT,
  typedValue: '',
  [Field.INPUT]: {
    currencyId: '',
  },
  [Field.OUTPUT]: {
    currencyId: '',
  },
  recipient: null,
  destinationType: null,
  zapInState: null
}

export default createReducer<ZapState>(initialState, (builder) => {
    builder
      .addCase(
        replaceZapState,
        (state, {payload: {typedValue, recipient, field, inputCurrencyId, outputCurrencyId}}) => {
          return {
            destinationType: "",
            zapInState: ZapInState.NONE,
            [Field.INPUT]: {
              currencyId: inputCurrencyId,
            },
            [Field.OUTPUT]: {
              currencyId: outputCurrencyId,
            },
            independentField: field,
            typedValue,
            recipient,
          }
        },
      )
      .addCase(selectCurrency, (state, {payload: {currencyId, field}}) => {
        const otherField = field === Field.INPUT ? Field.OUTPUT : Field.INPUT
        if (currencyId === state[otherField].currencyId) {
          // the case where we have to swap the order
          return {
            ...state,
            independentField: state.independentField === Field.INPUT ? Field.OUTPUT : Field.INPUT,
            [field]: {currencyId},
            [otherField]: {currencyId: state[field].currencyId},
          }
        }
        // the normal case
        return {
          ...state,
          [field]: {currencyId},
        }
      })
      .addCase(switchCurrencies, (state) => {
        return {
          ...state,
          independentField: state.independentField === Field.INPUT ? Field.OUTPUT : Field.INPUT,
          [Field.INPUT]: {currencyId: state[Field.OUTPUT].currencyId},
          [Field.OUTPUT]: {currencyId: state[Field.INPUT].currencyId},
        }
      })
      .addCase(typeInput, (state, {payload: {field, typedValue}}) => {
        return {
          ...state,
          independentField: field,
          typedValue,
        }
      })
      .addCase(setRecipient, (state, {payload: {recipient}}) => {
        state.recipient = recipient
      })
      .addCase(setDestinationType, (state, {payload: {destinationType}}) => {
        state.destinationType = destinationType
      })
      .addCase(setZapInState, (state, {payload: {zapInState}}) => {
        state.zapInState = zapInState
      });
  },
)
